import { Routes } from '@angular/router';
import { authChildGuard, authGuard, authPageGuard } from './features/auth/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () => import('./features/auth/pages/splash/splash.component')
      .then(m => m.SplashComponent)
  },
  {
    path: 'onboarding-intro',
    canActivate: [authPageGuard],
    loadComponent: () => import('./features/auth/pages/onboarding-intro/onboarding-intro.component')
      .then(m => m.OnboardingIntroComponent)
  },
  {
    path: 'onboarding',
    // Matches Flutter: the full profile/interests/notifications onboarding is
    // a post-auth route. First-run unauthenticated users enter via
    // /onboarding-intro from splash.
    canActivate: [authGuard],
    loadComponent: () => import('./features/auth/pages/onboarding/onboarding.component')
      .then(m => m.OnboardingComponent)
  },
  {
    path: 'login',
    canActivate: [authPageGuard],
    loadComponent: () => import('./features/auth/pages/login/login.component')
      .then(m => m.LoginComponent)
  },
  {
    path: 'register',
    canActivate: [authPageGuard],
    loadComponent: () => import('./features/auth/pages/register/register.component')
      .then(m => m.RegisterComponent)
  },
  {
    path: 'verify-email',
    canActivate: [authPageGuard],
    loadComponent: () => import('./features/auth/pages/verify-email/verify-email.component')
      .then(m => m.VerifyEmailComponent)
  },
  {
    path: 'forgot-password',
    canActivate: [authPageGuard],
    loadComponent: () => import('./features/auth/pages/forgot-password/forgot-password.component')
      .then(m => m.ForgotPasswordComponent)
  },
  {
    path: '',
    canActivateChild: [authChildGuard],
    loadComponent: () => import('./core/layout/app-shell/app-shell.component')
      .then(m => m.AppShellComponent),
    children: [
      {
        path: 'social',
        loadComponent: () => import('./features/social/pages/social-feed/social-feed.component')
          .then(m => m.SocialFeedComponent)
      },
      {
        path: 'marketplace',
        loadComponent: () => import('./features/marketplace/pages/marketplace-feed/marketplace-feed.component')
          .then(m => m.MarketplaceFeedComponent)
      },
      {
        path: 'jobs',
        loadComponent: () => import('./features/jobs/components/pages/jobs-feed/jobs-feed.component')
          .then(m => m.JobsFeedComponent)
      },
      {
        path: 'lumina-ai',
        loadComponent: () => import('./features/lumina-ai/pages/lumina-console/lumina-console.component')
          .then(m => m.LuminaConsoleComponent)
      },
      {
        path: 'services',
        loadComponent: () => import('./features/services/pages/services-feed/services-feed.component')
          .then(m => m.ServicesFeedComponent)
      },
      {
        path: 'riding',
        loadComponent: () => import('./features/riding/pages/riding-home/riding-home.component')
          .then(m => m.RidingHomeComponent)
      },
      {
        path: 'travel',
        loadComponent: () => import('./features/travel/pages/travel-home/travel-home.component')
          .then(m => m.TravelHomeComponent)
      },
      {
        path: 'profile',
        loadComponent: () => import('./features/profile/pages/profile-view/profile.component')
          .then(m => m.ProfileComponent)
      }
    ]
  },
  {
    path: 'settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/settings/pages/settings-home/settings.component')
      .then(m => m.SettingsComponent)
  },
  {
    path: 'notifications',
    canActivate: [authGuard],
    loadComponent: () => import('./features/notifications/pages/notifications-page/notifications-page.component')
      .then(m => m.NotificationsPageComponent)
  },
  {
    path: 'messages',
    canActivate: [authGuard],
    loadComponent: () => import('./features/messages/pages/messages-page/messages-page.component')
      .then(m => m.MessagesPageComponent)
  },
  {
    path: 'transactions',
    canActivate: [authGuard],
    loadComponent: () => import('./features/transactions/pages/transactions-page/transactions-page.component')
      .then(m => m.TransactionsPageComponent)
  },
  {
    path: 'challenges',
    canActivate: [authGuard],
    loadComponent: () => import('./features/challenges/pages/challenges-home/challenges.component')
      .then(m => m.ChallengesComponent)
  },
  {
    path: 'analytics',
    canActivate: [authGuard],
    loadComponent: () => import('./features/analytics/pages/analytics/analytics.component')
      .then(m => m.AnalyticsComponent)
  },
  {
    path: 'gallery',
    canActivate: [authGuard],
    loadComponent: () => import('./features/gallery/pages/gallery-view/gallery.component')
      .then(m => m.GalleryComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./shared/pages/not-found/not-found.component')
      .then(m => m.NotFoundComponent)
  }
];
